module.exports = __webpack_public_path__ + "img/lin.5f2f5dc7.svg";